<template>
  <div
      class="assertions-dynamics-card"
      :class="{ 'assertions-dynamics-card--empty': !hasChartData }"
  >
    <div
        v-if="hasChartData"
        class="assertions-dynamics-card__list"
    >
      <div
          v-for="(item, index) in normalizedItems"
          :key="item.text"
          class="assertions-dynamics-card__row"
      >
        <div class="assertions-dynamics-card__statement">
          <span>{{ index + 1 }}.</span>
          <span>{{ item.text }}</span>
        </div>

        <span
            class="assertions-dynamics-card__change"
            :class="{
              'positive-change': item.change > 0,
              'negative-change': item.change < 0,
              'neutral-change': item.change === 0
            }"
        >
          {{ getChangeText(item.change) }}
        </span>

        <span
            class="assertions-dynamics-card__users"
            :class="{
              'assertions-dynamics-card__users--underlined': item.users !== 0
            }"
        >
          {{ item.users }} чел.
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'AssertionsDynamicsCard',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  setup(props) {
    const normalizedItems = computed(() => {
      return props.items.map((item) => {
        const change = Number(item.change)
        const users = Number(item.users)

        return {
          ...item,
          change: Number.isFinite(change) ? change : 0,
          users: Number.isFinite(users) ? users : 0,
        }
      })
    })

    const hasChartData = computed(() => {
      return normalizedItems.value.length > 0
    })

    const getChangeText = (value) => {
      if (value > 0) {
        return `↑ ${value}%`
      }

      if (value < 0) {
        return `↓ ${Math.abs(value)}%`
      }

      return '–'
    }

    return {
      normalizedItems,
      hasChartData,
      getChangeText,
    }
  },
}
</script>

<style scoped lang="scss">
.assertions-dynamics-card {
  margin-top: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: start;
}

.assertions-dynamics-card--empty {
  min-height: 160px;
  margin-top: 0;
  justify-content: center;
}

.assertions-dynamics-card__list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.assertions-dynamics-card__empty {
  align-self: center;
  margin: auto;
  padding: 6px 12px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fff;
  font-weight: 400;
  font-size: 12px;
  line-height: 110%;
  text-align: center;
  white-space: nowrap;
}

.assertions-dynamics-card__row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(30px, 40px) minmax(30px, 60px);
  align-items: start;
  column-gap: 16px;
  min-width: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.assertions-dynamics-card__statement {
  display: grid;
  grid-template-columns: 16px minmax(0, 1fr);
  column-gap: 2px;
  min-width: 0;
}

.assertions-dynamics-card__statement span:last-child {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.assertions-dynamics-card__change {
  min-width: 0;
  white-space: nowrap;
  text-align: right;
}

.assertions-dynamics-card__users {
  min-width: 50px;
  color: rgba(0, 0, 0, 0.88);
  text-align: right;
  white-space: nowrap;
}

.assertions-dynamics-card__users--underlined {
  text-decoration: underline;
  cursor: pointer;
}

.positive-change {
  color: var(--main-green);
}

.negative-change {
  color: #F55565;
}

.neutral-change {
  color: rgba(0, 0, 0, 0.45);
}

@media (max-width: $mobile-breakpoint) {
  .assertions-dynamics-card__row {
    grid-template-columns: minmax(0, 1fr) minmax(30px, 40px) minmax(30px, 60px);
    column-gap: 12px;
  }

  .assertions-dynamics-card__users {
    min-width: 50px;
  }
}
</style>
